import api from 'utils/api';
import { objectToQueryString } from 'utils/helpers';

const servicePath = '/services/recovery-price';

export const list = async (params) => {
  const query = objectToQueryString(params);
  const { data } = await api.get(`${servicePath}/list${query ? '?' + query : ''}`);
    
  return data;
}